import React, { FC } from 'react';

import { TextDirection } from '@yubi/phoenix-provider';
import { Typography } from '@yubi/yb-core-typography-v3';

export type TypographyVariants =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'sh1'
  | 'sh2'
  | 'sh3'
  | 'sh4'
  | 'sh5'
  | 'sh6'
  | 'b1'
  | 'b2'
  | 'b3'
  | 'b4'
  | 'b5'
  | 'b6'
  | 's1'
  | 's2'
  | 's3'
  | 's4'
  | 's5'
  | 't1'
  | 't2'
  | 'sp1'
  | 'sp2'
  | 'sp3'
  | 'd1';
export interface TypographyProps {
  direction?: TextDirection;
  variant?: TypographyVariants;
  children: React.ReactNode;
  color?: string;
  transform?: 'capitalize' | 'lowercase' | 'uppercase' | 'none';
  textDecoration?:
    | 'line-through'
    | 'none'
    | 'underline'
    | 'underline line-through';
}
export interface Variant {
  size: number;
  lineHeight: number;
  fontWeight: number;
  fontStyle: 'normal' | 'italic';
  type: string;
}

const TextViewV3: FC<TypographyProps> = ({ variant, children, color }) => {
  return (
    <Typography variant={variant} color={color}>
      {children}
    </Typography>
  );
};

export default TextViewV3;
